<header [ngClass]="{'opened': header_status.opened }" class="container">
  <h1>Sign'em</h1>
  <img id="main-logo" [src]="company!=null && company.ro_logo_url!=null ? company.ro_logo_url : '/assets/img/logo/logo-white-shadow.png'" alt="sign'em" />
  <ng-container *ngIf="header_status.opened && svg!=null">
    <p class="contrastable"><b>{{ header_status.bold_text }}</b>{{ header_status.text }}</p>
    <div id="header-opened-icon" [innerHtml]="svg"></div>
  </ng-container>
</header>

<div class="container" id="content">
  <router-outlet></router-outlet>
</div>

<footer class="container">
  <ul>
    <li [ngClass]="{'active': auth_step > 0}"></li>
    <li [ngClass]="{'active': auth_step > 1}"></li>
    <li [ngClass]="{'active': auth_step > 2}"></li>
  </ul>

  <div class="footer-signature">
    {{ 'aTechnologiFrom' | translate }}
    <img src="/assets/img/logo/logo.png" alt="signem" />
    <!-- Selector available Languages using flag -->
    <mat-select [(value)]="selectedLanguage" disableRipple (selectionChange)="changeLanguage($event)">
      <mat-select-trigger>
        <img *ngIf="selectedLanguage" [src]="selectedLanguage.flag" alt="flag" class="language-flag" />
      </mat-select-trigger>
      <mat-option *ngFor="let language of availableLanguages" [value]="language">
        <img [src]="language.flag" alt="flag" class="language-flag" />
      </mat-option>
    </mat-select>

  </div>
</footer>
